package org.dronda.app.web.repository

import com.github.michaelbull.result.Result
import org.dronda.api.wishlist.AddWishlistItem
import org.dronda.api.wishlist.CreateWishList
import org.dronda.api.wishlist.EditWishlistItem
import org.dronda.api.wishlist.WishListFull
import org.dronda.app.web.client.WishlistClient

class WishlistRepository(
    private val wishlistClient: WishlistClient
) {

    suspend fun getWishlist(wishlistId: String): Result<WishListFull, Unit> {
        return wishlistClient.getWishlist(wishlistId)
    }

    suspend fun createWishlist(request: CreateWishList): Result<Unit, Unit> {
        return wishlistClient.createWishlist(request)
    }

    suspend fun addItem(wishlistId: String, item: AddWishlistItem): Result<Unit, Unit> {
        return wishlistClient.addItem(wishlistId, item)
    }

    suspend fun updateItem(
        wishlistId: String,
        itemId: String,
        item: EditWishlistItem
    ): Result<WishListFull, Unit> {
        return wishlistClient.updateItem(wishlistId, itemId, item)
    }

    suspend fun deleteItem(wishlistId: String, itemId: String): Result<Unit, Unit> {
        return wishlistClient.deleteItem(wishlistId, itemId)
    }

    suspend fun toggleItemPurchaseStatus(
        wishlistId: String,
        itemId: String
    ): Result<WishListFull, Unit> {
        return wishlistClient.toggleItemPurchaseStatus(wishlistId, itemId)
    }
}
